<div class="toolbar" role="banner">

  <!-- <div class="topActions">
    <button (click)="showHideExport()"> Feedback </button>
    <div class="topActions accord" *ngIf="showHideExportDiv == true">
      <p class="exportHeader"> Export webchat feedback CSV </p>
      <mat-label> Feedback date</mat-label>
      <mat-form-field class="example-full-width">
        <mat-label>Choose a date</mat-label>
        <input matInput [max]="maxDate" [matDatepicker]="picker3" [(ngModel)]="startDate">
        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
        <mat-datepicker #picker3></mat-datepicker>
      </mat-form-field>
      <button (click)="downloadFeedbackReport()"> Submit </button>
      <button class="clearButton" (click)="showHideExport()"> Exit </button>
    </div>
  </div>
  <div class="spliter"></div> -->
  <div *ngIf="(appData.data.length > 0)">
    <span class="menu-title">App:</span>
    <button mat-button *ngIf="appData.selectedApp"
      [matMenuTriggerFor]="appMenu">{{ appData.selectedApp ? appData.selectedApp.project_name : "" }}</button>
    <mat-menu #appMenu="matMenu">
      <button mat-menu-item (click)="onAppChange(app)" *ngFor="let app of appData.data">{{ app.project_name }}</button>
    </mat-menu>

  </div>
  <div class="spliter"></div>

  <div></div>
  <span class="menu-title">Channel:</span>
  <button mat-button [matMenuTriggerFor]="channelMenu">{{ channel.selectedChannel.label}}</button>
  <mat-menu #channelMenu="matMenu">
    <button mat-menu-item (click)="onChannelChange(channel)"
      *ngFor="let channel of channel.data">{{ channel.label }}</button>
  </mat-menu>

  <div class="spliter"></div>

  <span class="menu-title">Language:</span>
  <button mat-button [matMenuTriggerFor]="languageMenu">{{ language.selectedLanguage.label}}</button>
  <mat-menu #languageMenu="matMenu">
    <button mat-menu-item (click)="onLanguageChange(lang)" *ngFor="let lang of language.data">{{ lang.label }}</button>
  </mat-menu>

</div>